import { getSlidesPerView } from "./getSlidesPerView";
export var shouldShowNavigationArrows = function shouldShowNavigationArrows(_ref) {
  var navigation = _ref.navigation,
    slider = _ref.slider,
    slidesCount = _ref.slidesCount;
  return (navigation === null || navigation === void 0 ? void 0 : navigation.showArrows) === true && slidesCount > getSlidesPerView(slider);
};
//# sourceMappingURL=shouldShowNavigationArrows.js.map